<template lang="html">
	<section class="take-place master-transactions column">
		<div class="white-box row ctn-transactions-reminder">
			<div class="ctn-icon">
				<span class="icon-operations-folder"></span>
			</div>
			<div class="column labels">
				<div class="title">
		  		Vous avez <span class="bold">{{ subscriptions.length }} abonnement{{ (subscriptions.length > 1) ? 's' : '' }}</span>
				</div>
			</div>
			<router-link :to="{ name: 'MySubscriptionsAdd' }" class="btn btn-red ctn-icon">
				<span class="icon-button-new-mission"></span>
				Nouvel abonnement
			</router-link>
		</div>
		<div class="label">
			Abonnements
		</div>
		<ag-table :rows="computedRows" :columns="cols" :customOptions="options"/>
	</section>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	name: 'TableSubscriptions',
	data () {
		return {
			cols: [
				{ name: 'Client', field: 'client', cellType: 'light', width: 230 },
				{ name: 'Plan', field: 'plan', cellType: 'light', width: 220 },
				{ name: 'Prochain prélèvement', field: 'next_billing_date', cellType: 'date', width: 260 },
				{ name: 'Contrat', field: 'letter', cellType: 'statusMission', width: 220 },
				{ name: 'Statut', field: 'status', width: 350, cellRenderer: this.subscriptionStatusRenderer }
//				{ name: 'Montant', field: 'amount', cellType: 'light', width: 160 }
			],
			options: {
				onRowClicked: (data) => {
					this.$router.push({name: 'MySubscriptionsEdit', params: { id: data.data.id }})
				},
				localeText: {
					noRowsToShow: 'Vous n\'avez pas encore d\'abonnement'
				}
			}
		}
	},
	mounted () {
		this.$store.dispatch('getSubscriptions')
	},
	methods: {
		subscriptionStatusRenderer ({value}) {
			let foo = '<div class="custom-cell status-missions row '
			switch (value.name) {
			case 'contract_waiting':
			case 'payment_method_waiting':
				foo += 'orange"><div class="ctn-icon"><span class="icon-alert"></span></div>'
				break
			case 'enabled':
				foo += 'green"><div class="ctn-icon"></div>'
				break
			}
			return foo + '<div class="">' + value.label + '</div></div>'
		},
		resolveDocs (subscription, type) {
			const doc = subscription.documents.filter(doc => doc.sub_category === type)[0]
			if (doc) {
				if (doc.universign_status === 'ready') {
					return 'En Attente'
				} else if (doc.universign_status === 'completed') {
					return 'Signé'
				} else {
					return 'En Attente'
				}
			} else {
				return 'À envoyer'
			}
		}
	},
	computed: {
		computedTotal () {
			let total = 0
			this.subscriptions.forEach((operation) => {
				total += operation.total_value
			})

			return total
		},
		...mapGetters({
			subscriptions: 'subscriptions'
		}),
		computedRows () {
			const rows = []
			this.subscriptions.forEach((subscription) => {
				rows.push({
					id: subscription.id,
					client: subscription.user.first_name + ' ' + subscription.user.last_name,
					plan: subscription.plan.name,
					next_billing_date: this.$moment(subscription.next_billing_date, 'DD/MM/YYYY HH:mm'),
					letter: this.resolveDocs(subscription, 'Contrat d\'abonnement'),
					status: {label: subscription.status_label, name: subscription.status}
				})
			})

			return rows
		}
	},
	filters: {
		moneyFilter (value) {
			const val = value.toString()
			let result = ''
			const integer = val.split('.')[0].split('')
			const decimal = val.split('.')[1]
			while (integer.length > 3) {
				result = '.' + integer.splice(integer.length - 3, integer.length).join('') + result
			}
			result = integer.join('') + result
			result += ',' + (decimal || '00')

			return result
		}
	}
}
</script>

<style lang="scss">
.status-missions {
float: left !important;
}
</style>



// WEBPACK FOOTER //
// Table.vue?0fb5fb9a